export * from './sidebar.directive';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/directives/sidebar/index.ts